import React from 'react'
import { ArrayField, Datagrid, FunctionField } from 'react-admin'
import KAccordion from './accordions/KAccordion'
import { CustomFormProps } from 'types/common'
import Kdivider from './LayoutComponents/Kdivider'
import LocalizedTextField from './LocalizedFields/LocalizedTextField'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { MainProduct } from 'services/api/entities/catalog/mainProduct/types/internal/mainProduct-models'
// import { APILinkedThenClauseRule } from 'services/api/entities/catalog/types'
// can't on <FunctionField render type as ApiLinkedThenClauseRule actually is any line 47

type Props = CustomFormProps & {
  supportsIfClause?: boolean
}

const LinkedRulesPanel: React.FC<Props> = ({ supportsIfClause = true }) => {
  const record = useKRecordContext<MainProduct>()
  const hasThenClauses = !!record?.thenClauseLinkedRules?.length
  const hasIfClauses = !!record?.ifClauseLinkedRules?.length

  return (
    <KAccordion accordionTitle="Associated Rules">
      {supportsIfClause ? (
        hasIfClauses ? (
          <>
            <h3>
              This product is associated to the the following if Conditions:
            </h3>
            <ArrayField source="ifClauseLinkedRules" sortable={false}>
              <Datagrid>
                <LocalizedTextField source="ruleName" />
              </Datagrid>
            </ArrayField>
          </>
        ) : (
          <h3>This product has not associated if Conditions:</h3>
        )
      ) : null}
      <Kdivider />
      {hasThenClauses ? (
        <>
          <h3>
            This product is associated to the the following then Conditions:
          </h3>
          <ArrayField source="thenClauseLinkedRules">
            <Datagrid>
              <LocalizedTextField source="ruleName" sortable={false} />
              <LocalizedTextField source="action" sortable={false} />

              <FunctionField
                label="Rules services Where"
                render={(thenClauseLinkedRules: any) =>
                  thenClauseLinkedRules.ruleServicesWhere.join(' ')
                }
              />
            </Datagrid>
          </ArrayField>
        </>
      ) : (
        <h3>This product has not associated then Conditions:</h3>
      )}
    </KAccordion>
  )
}

export default LinkedRulesPanel
